import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import classNames from 'classnames'

import { I18n } from 'shared'

export default class SelectField extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    hint: PropTypes.string,
    options: PropTypes.array.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.array,
      PropTypes.object
    ]),
    required: PropTypes.bool,
    cssClass: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onInputChange: PropTypes.func,
    hasError: PropTypes.bool,
    errorMessage: PropTypes.string,
    isMulti: PropTypes.bool,
    isDisabled: PropTypes.bool,
    closeMenuOnSelect: PropTypes.bool,
    placeholder: PropTypes.string,
    noOptionsMessage: PropTypes.string,
    isLoading: PropTypes.bool,
    isClearable: PropTypes.bool,
    testid: PropTypes.string
  }

  static defaultProps = {
    hasError: false,
    isMulti: false,
    isLoading: false,
    isClearable: true,
    closeMenuOnSelect: true,
    testid: '',
    onInputChange: () => {}
  }

  state = {
    hasEdited: false
  }

  selectOptions = (arr) => {
    return arr.map((obj) => {
      return { label: obj[0] || obj.label, value: `${obj[1] || obj.value}` }
    })
  }

  getValue = (opts, val) =>
    this.selectOptions(opts).filter((o) => {
      return val instanceof Array ? val.includes(o.value) : o.value === val
    })

  render() {
    const {
      label,
      required,
      value,
      name,
      hint,
      options,
      onChange,
      onInputChange,
      cssClass,
      hasError,
      errorMessage,
      placeholder,
      noOptionsMessage,
      isMulti,
      isLoading,
      isDisabled,
      isClearable,
      closeMenuOnSelect,
      testid
    } = this.props
    const { hasEdited } = this.state

    return (
      <div data-testid={testid} className={classNames('form-group', cssClass)}>
        {label && (
          <label className={'form-control-label'} htmlFor={name}>
            {label}
            {required && <abbr title={I18n.t('common.required')}>*</abbr>}
          </label>
        )}
        <Select
          isLoading={isLoading}
          name={name}
          instanceId={name}
          value={this.getValue(options, value) || false}
          options={this.selectOptions(options)}
          placeholder={placeholder}
          onChange={(e, meta) => {
            this.setState({ hasEdited: true })
            if (meta.action === 'clear') {
              if (isMulti) {
                onChange(e)
              } else {
                onChange({ value: '' })
              }
            } else {
              onChange(e)
            }
          }}
          onInputChange={onInputChange}
          className={classNames({ 'is-invalid': hasError && !hasEdited })}
          isMulti={isMulti}
          isClearable={isClearable}
          isDisabled={isDisabled}
          hideSelectedOptions={true}
          openMenuOnFocus={true}
          noOptionsMessage={() => {
            return noOptionsMessage || I18n.t('common.no_options_available')
          }}
          closeMenuOnSelect={closeMenuOnSelect}
          classNamePrefix="react-select"
          styles={{ option: () => ({}) }}
        />
        {hint && <small className="form-text text-muted">{hint}</small>}
        {hasError && errorMessage && (
          <small className="text-sm text-danger">{errorMessage}</small>
        )}
      </div>
    )
  }
}
